import { twMerge } from "tailwind-merge";

export function Heading4({
  children,
  elementType,
  className,
}: {
  children: React.ReactNode;
  elementType: "h2" | "h3" | "h4";
  className?: string;
}) {
  const Element = elementType;

  return (
    <Element
      className={twMerge(
        "text-xl font-semibold tracking-tight text-gray-900",
        className
      )}
    >
      {children}
    </Element>
  );
}
